<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 营销模块
        </el-breadcrumb-item>
        <el-breadcrumb-item>奖品管理-积分</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item label="分组名称" prop="group">
                <el-input v-model.trim="searchform.group" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button type="primary" @click=" update.show=false,add.addshow=!add.addshow">添加奖品</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!--步骤条 填写基础信息 -->
        <add-prize  :add="add" :search="search" />
        <update-prize  ref="mychild"  :update="update" :search="search" />
            <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>奖品管理列表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            id="parent"
          >
            <el-table-column prop="orderno" label="图片" min-width="100" >
              <template slot-scope="props">
                <el-image
                 style="width: 120px; height: 40px"
                 :src="imgsrc+props.row.awardStuffImageurl"
                 :preview-src-list="[imgsrc+props.row.awardStuffImageurl]"
                fit="scale-down"></el-image>
             </template>
            </el-table-column>
            <el-table-column prop="awardStuffTypename" label="奖品类型" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="awardStuffName" label="奖品名称" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="awardStuffTotal" label="总量" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="awardStuffUsed" label="已兑换数量" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="详细详细" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="添加时间" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="barterFlag" label="操作" min-width="120" show-overflow-tooltip>
                <template slot-scope="props">
                <el-button-group>
              <el-button type="primary" @click="updateaward(props.row),add.addshow=false" v-permission="['prizemanage_update']"   icon="el-icon-edit"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="deletedate(props.row.awardStuffUuid)" v-permission="['prizemanage_delete']"></el-button>
              </el-button-group>
               </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { AccumulatePointfindall,queryFile,awardStuffAccumulatePointdel } from "@/api/market/marketing";
import AddPrize from "./components/AddPrize";
import UpdatePrize from "./components/UpdatePrize";
//引入导出组件模块
export default {
  name: "prizemanage",
  components: { AddPrize,UpdatePrize },
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      add:{
         addshow: false,
      },
      update:{
          show: false,
          ifFile: false,
         row: {},
          awardform: {
            awardStuffName: null,
            awardStuffType: null,
            awardStuffCount: null,
            awardStuffGroup: null,
            awardStuffImageurl: null,
            awardStuffIstop: false,
            remark: null
          },
          fileList: []
      },
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        group: null,
        rows: 10,
        page: 1
      },
        imgsrc:process.env.VUE_APP_BASE_API + "/mtscitech/back/filegetter/queryFile?fileType=image/jpeg&adress=",
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      AccumulatePointfindall(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
         switch (Number(obj[i].awardStuffType)) {
             case 0:obj[i].awardStuffTypename = '红包'      
             break;
             case 1:obj[i].awardStuffTypename = '积分'      
             break;
             case 2:obj[i].awardStuffTypename = '实物'      
             break;
             case 3:obj[i].awardStuffTypename = "优惠卷"
             break;
         }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        group: this.searchform.group,
        rows: this.searchform.rows,
        page: this.searchform.page
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.page = currPage;
      this.Tabledata({
        group: this.searchform.group,
        rows: this.searchform.rows,
        page: this.searchform.page
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.rows = pageSize;
      this.search();
    },
    // 修改操作
    updateaward(row){
      document.getElementById('A1').scrollIntoView({// 锚点定位
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth'
        })
      this.update.fileList = [];
      this.update.awardform = row;
      this.update.row = row;
      this.update.show = true 
      if (row.awardStuffImageurl) { // 有图片这添加到列表
             this.update.fileList.push({name:"yage",url:this.imgsrc + row.awardStuffImageurl})  
      }
      console.log(this.update.awardform.awardStuffType)
    },
        //删除按钮事件
    deletedate(obj) {
      this.$confirm("此操作将永久删除该规则信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          awardStuffAccumulatePointdel({
            uuid: obj
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
  }
};
</script>
<style scoped>
</style>